<!--
/**
  * 树组件
  * 说明：配置任意业务数据来源和任意统计数据来源，生成不同的树（可配置是否显示统计数），并过滤右侧表格数据
  * @author weili
  * @date 2022-12-16

  fetchTableData: 点击树节点的回调函数
       -codeStr  当前点击的树节点及下级节点的key集合
       -item     当前点击的树节点值对象
       -containsNull  当前点击的是无关联节点时该值为containsNull：后端要判断如果是这个值，要增加查询列表关联字段为空值的记录
  
  checkTreeData   多选树节点的回调函数
       -item  
              -isChecked 是否被选中
              -nodeObj  值对象
       */
-->
<template>
  <div>
      <ETree
          ref="exTree"
          :treeKey="treeKey"
          :treeTitle="treeTitle"
          :showCheckbox="showCheckbox"
          :treeList="treeList"
          :treeNodeFilter="treeNodeFilter"
          :defaultProps="defaultProps"
          :checkedKey="checkedKey"
          :showIcon="showIcon"
          :checkStrictly="checkStrictly"
          :defaultKeys="defaultKeys"
          @fetchTableData="fetchTableDataFn"
          @checkTreeData="checkTreeData"
          :treeIcon="treeIcon"
          nodeWidth="100%"
      ></ETree>
  </div>
</template>
<script>
import ETree from "./tree.vue";
import getTree from '@/mixins/getMultiTree'
export default {
  name: 'EXTree',
  components: {
    ETree
  },
  mixins: [getTree],
  props:{
    numberLoad:{      //树节点默认不显示统计的数字，false时无需配置treeCountApi
      type: Boolean, 
      default: false,
    },
    treeDataApi:{    // 树api接口的方法
      type: Function, 
      default: null
    },
    treeCountApi:{    // 统计api接口的方法
      type: Function,
      default: null
    },
    treeDataParams:{  //树接口传递的查询参数
      type: Object,
      default:()=>({})
    },
    treeCountParams:{  //统计接口传递的查询参数
      type: Object,
      default:()=>({})
    },
    defaultProps:{
      type: Object,
      default: () => ({
          dataCode: "dataCode",  //业务表中对应树节点key的字段名
          dataName: "dataName",   //业务表中对应树节点中文名称的字段名
      })
    },
    noRelationProps:{
      type: Object,
      default: () => ({
        noRelationKey: "-1",       //无关联节点key设置
        noRelationValue: "无关联", //无关联节点名称设置
        noRelationKeyQuery: false, //点击无关联节点时是否按照设置的key查询，默认false：按照表格记录的实际关联编码的值逗号拼接查询
      })
    },
    treeIcon:String,   //自定义叶子节点图标图片
    treeNodeFilter:{  //是否显示过滤输入框
      type: Boolean,
      default:false
    },
    treeTitle:String,
    showCheckbox:{      //是否多选
      type: Boolean, 
      default: false,
    },
    checkedKey: {
        type: String,
        default: '全部'
    },
     // 是否展示图标
     showIcon: {
        type: Boolean,
        default: true,
      },
    // 在显示复选框的情况下，是否严格的遵循父子不互相关联的做法
    checkStrictly: {
      type: Boolean,
      default: false,
    },
    defaultKeys:{
      type: Array,
      default: () => ([])
    },
    // 节点id
    treeKey: {
      type: String,
      default: "label",
  },
   //树数据直接赋值，无需配置treeDataApi等
    treeData:{
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      treeList: []
    };
  },
  //监听父页面对treeData的赋值变化，更新treeList
  watch: {
    treeData (val) {
      this.treeList = val;
    },
  },
  mounted(){
    if(this.treeData && this.treeData.length > 0){
      this.treeList = this.treeData;
    }
  },
  methods: {
    fetchTableDataFn(codeStr,item,containsNull){
      this.$emit("fetchTableData",codeStr,item,containsNull);
    },
    checkTreeData(item){
      this.$emit("checkTreeData",item);
    }
  }
}
</script>
 <style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/EXTree/index.vue